import { IconButton, styled } from '@mui/material';

export const iconStyle = {
    color: 'inherit',
    width: '36px',
    height: '36px',
};
const dayBoxHeight = 19;
export const DayBox = styled('div')`
    color: #ffffff;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0;
    height: ${dayBoxHeight}px;
    line-height: ${dayBoxHeight}px;
    text-align: center;
    text-transform: uppercase;
`;
export const DateBox = styled('div')`
    color: #ffffff;
    font-family: Roboto, serif;
    font-size: 28px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 33px;
    text-align: center;
    text-transform: uppercase;
    cursor: pointer;
    flex-shrink: 0;
`;
export const NavBox = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${dayBoxHeight}px; // ensures symmetry with DayBox
    & .Mui-selected {
        color: white !important;
    }
`;
export const HandleIconButton = styled(IconButton)(({ theme }) => ({
    padding: 0,
    width: 36,
    height: 36,
    color: theme.palette.blue.lightest,
}));
